<template>
    <div class="m-portlet m-portlet--head-sm">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        学生情况
                    </h3>
                </div>
            </div>
        </div>

        <div class="m-portlet__body infinite-list-wrapper">
            <div class="m-widget4" v-infinite-scroll="load"
                 infinite-scroll-disabled="disabled">
                <div class="m-widget4__item"
                     v-for="item in _.orderBy($parentInfo.Task_StudentSituation.data, ['isRead','id'],['asc','desc'])"
                     :key="item.id">
                    <div class="m-widget4__left">
                        <el-tag type="danger">{{item.status_name}}</el-tag>
                    </div>
                    <div class="m-widget4__info">
                        <span class="m-widget4__title">
                            {{item.name}}<span style="margin-right: 10px"></span>班主任：{{item.headTeacher_name}}
                        </span><br>
                        <span class="m-widget4__title" v-if="item.new_situation">
                            <div style="display: flex;flex-direction:row; justify-content:space-between">
                                <div>{{item.new_situation.class_name}}</div>
                                <div>{{item.new_situation.date}}<span style="margin-right: 5px"></span>{{item.new_situation.time}}</div>
                                <div>{{item.new_situation.teacher_name}}</div>
                            </div>
                        </span>
                        <span class="m-widget4__sub" v-if="item.old_situation && item.new_situation">
                            <div style="display: flex;flex-direction:row; justify-content:space-between">
                                <div v-if="item.new_situation.class_name==item.old_situation.class_name">{{item.old_situation.class_name}}</div>
                                <div v-else class="different-border">{{item.old_situation.class_name}}</div>
                                <div v-if="item.new_situation.date==item.old_situation.date">{{item.old_situation.date}}</div>
                                <div v-else class="different-border">{{item.old_situation.date}}</div>
                                <div v-if="item.new_situation.teacher_name==item.old_situation.teacher_name">{{item.old_situation.teacher_name}}</div>
                                <div v-else class="different-border">{{item.old_situation.teacher_name}}</div>
                            </div>
                        </span>
                    </div>
                    <span class="m-widget4__ext">
                        <span class="m-widget4__number m--font-brand circle"
                              :style="{'background-color':item.isRead===1?'#548057':'white'}"
                              @click="handleRead(item.id)"></span>
                    </span>
                </div>
            </div>
            <p v-if="loading">加载中...</p>
            <p v-if="noMore">没有更多了</p>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Task_Refund",
        data() {
            return {
                currentPageSize: 10,
                currentPage: 1,
                count: 10,
                loading: false,
                waiting: false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.$parentInfo.path, this.handleData);
        },
        computed: {
            noMore() {
                return this.count === 0
            },
            disabled() {
                return this.loading || this.noMore
            }
        },
        methods: {
            handleRead(id) {
                this.$wApi.send(this.$parentInfo.path, 'read_studentSituation', {'id': id});
            },
            handleData(event, data) {
                switch (event) {
                    case 'init_studentSituation':
                        // console.log(this.waiting);
                        this.count = data.total;
                        this.waiting = false;
                        this.loading = false;
                        // console.log(this.waiting);
                        break;
                }
            },
            load() {
                if(this.$parentInfo.task_scroll){
                    this.loading = true;
                    if (!this.waiting) {
                        this.currentPage++;
                        this.waiting = true;
                        this.$wApi.send(this.$parentInfo.path, 'init_studentSituation',
                            {'currentPageSize': this.currentPageSize,
                                'currentPage': this.currentPage,
                                'semester_id':this.$parentInfo.filter.semester_id});
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .infinite-list-wrapper {
        height: 300px;
        overflow: auto;
    }

    .circle {
        display: inline-block;
        margin-right: 5px;
        border-radius: 8px; /* 圆形边缘弧度 */
        width: 16px; /* 宽度 */
        height: 16px; /* 高度 */
        border: 1px solid gray;
    }

    .elements {
        display: inline-block;
        margin-right: 5px;
        border-radius: 25px; /* 圆形边缘弧度 */
        width: 50px; /* 宽度 */
        height: 20px; /* 高度 */
        border: 1px solid gray;
        text-align: center;
        color: white;
    }

    .different-border {
        border: 1px dashed #F00;
    }
</style>
